document.addEventListener('DOMContentLoaded', () => {
  // We wrap all code inside a self-initializing check for Ecotrophy PDP sections
  const initEcotrophyPDP = () => {
    const sectionContainers = document.querySelectorAll('.ecotrophy-product-container');
    
    sectionContainers.forEach(container => {
      const sectionId = container.querySelector('.ecotrophy-media-gallery').getAttribute('data-section-id');
      if (!sectionId) return;

      // ----------------------------------------------------
      // Dom Elements
      // ----------------------------------------------------
      const gallery = document.getElementById(`EcotrophyMediaGallery-${sectionId}`);
      const infoCard = document.getElementById(`EcotrophyProductInfoCard-${sectionId}`);
      const modal = document.getElementById(`EcotrophyZoomModal-${sectionId}`);
      const form = document.getElementById(`EcotrophyProductForm-${sectionId}`);
      
      // Only gallery is required; infoCard and modal are optional
      if (!gallery) return;

      const mediaGrid = gallery.querySelector('.ecotrophy-swiper-wrapper-mobile');
      const dots = gallery.querySelectorAll('.ecotrophy-dot');
      const imageButtons = gallery.querySelectorAll('.ecotrophy-media-button');
      
      const hiddenSelect = form ? (form.querySelector(`#AsideProductSelect-${sectionId}`) || form.querySelector(`#ProductSelect-${sectionId}`)) : null;
      const optionButtons = form ? form.querySelectorAll('.allbirds-swatch-btn, .allbirds-size-btn, .ecotrophy-option-btn') : [];
      const qtyInput = form ? (form.querySelector('.allbirds-qty-input') || form.querySelector('.ecotrophy-qty-input')) : null;
      const qtyPlusBtn = form ? (form.querySelector('.qty-plus-btn') || form.querySelector('.qty-plus')) : null;
      const qtyMinusBtn = form ? (form.querySelector('.qty-minus-btn') || form.querySelector('.qty-minus')) : null;
      const addToCartBtn = document.getElementById(`AsideAddToCartButton-${sectionId}`) || document.getElementById(`AddToCartButton-${sectionId}`);
      const priceText = document.getElementById(`AsideDisplayPrice-${sectionId}`) || document.getElementById(`ProductPrice-${sectionId}`);
      const comparePriceText = document.getElementById(`AsideComparePrice-${sectionId}`) || document.getElementById(`ComparePrice-${sectionId}`);
      const discountText = document.getElementById(`DiscountPercent-${sectionId}`);
      const priceContainer = document.getElementById(`PriceContainer-${sectionId}`);
      const whatsappBtn = document.getElementById(`WhatsAppQuoteButton-${sectionId}`) || document.getElementById(`BulkWhatsAppBtn-${sectionId}`);

      const modalCloseBtn = modal ? modal.querySelector('.ecotrophy-zoom-close') : null;
      const modalThumbs = modal ? modal.querySelectorAll('.ecotrophy-modal-thumb-btn') : [];
      const modalSlides = modal ? modal.querySelectorAll('.ecotrophy-zoom-slide') : [];
      const prevBtn = modal ? modal.querySelector('.prev-btn') : null;
      const nextBtn = modal ? modal.querySelector('.next-btn') : null;

      // Scroll Position memory for modal lock
      let scrollPos = 0;
      let activeImageIndex = 1;

      // ----------------------------------------------------
      // Zoom Modal Interactions
      // ----------------------------------------------------
      
      const lazyLoadModalSlide = (index) => {
        if (!modal) return;
        const slide = modal.querySelector(`.ecotrophy-zoom-slide[data-slide-index="${index}"]`);
        if (!slide) return;
        const img = slide.querySelector('.ecotrophy-zoom-large-img');
        if (img && img.dataset.src && img.src.startsWith('data:')) {
          img.src = img.dataset.src;
        }
      };

      const setModalActiveSlide = (index) => {
        activeImageIndex = parseInt(index);
        
        // Lazy load active + neighboring slides
        lazyLoadModalSlide(activeImageIndex);
        if (activeImageIndex > 1) lazyLoadModalSlide(activeImageIndex - 1);
        if (activeImageIndex < modalSlides.length) lazyLoadModalSlide(activeImageIndex + 1);

        // Toggle visibility of each slide to match Allbirds layout
        modalSlides.forEach(slide => {
          const slideIdx = parseInt(slide.getAttribute('data-slide-index'));
          if (slideIdx === activeImageIndex) {
            slide.style.display = 'flex';
          } else {
            slide.style.display = 'none';
          }
        });

        // Update Mobile Nav controls states
        if (prevBtn && nextBtn) {
          prevBtn.disabled = activeImageIndex === 1;
          nextBtn.disabled = activeImageIndex === modalSlides.length;
        }

        // Update Sidebar Thumbnails active class
        modalThumbs.forEach(btn => {
          if (parseInt(btn.getAttribute('data-thumb-index')) === activeImageIndex) {
            btn.classList.add('active');
            // Scroll thumbnail into view
            btn.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          } else {
            btn.classList.remove('active');
          }
        });
      };

      const openModal = (index) => {
        if (!modal) return;
        // Lock body scrolling and store positions
        scrollPos = window.scrollY || window.pageYOffset;
        document.body.style.top = `-${scrollPos}px`;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';

        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
        setModalActiveSlide(index);
      };

      const closeModal = () => {
        if (!modal || !modal.classList.contains('is-active')) return;

        // Restore body scrolling
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        window.scrollTo(0, scrollPos);

        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');
      };

      // Zoom triggers when clicking the full image button tile
      imageButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const index = btn.getAttribute('data-media-index');
          openModal(index);
        });
      });

      // Mobile Arrow navigation click triggers
      if (prevBtn && nextBtn) {
        prevBtn.addEventListener('click', () => {
          if (activeImageIndex > 1) {
            setModalActiveSlide(activeImageIndex - 1);
          }
        });

        nextBtn.addEventListener('click', () => {
          if (activeImageIndex < modalSlides.length) {
            setModalActiveSlide(activeImageIndex + 1);
          }
        });
      }

      // Modal thumb triggers
      modalThumbs.forEach(btn => {
        btn.addEventListener('click', () => {
          const index = btn.getAttribute('data-thumb-index');
          setModalActiveSlide(index);
        });
      });

      // Close handlers
      if (modalCloseBtn) {
        modalCloseBtn.addEventListener('click', closeModal);
      }
      
      // Escape key closing
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          closeModal();
        }
      });

      // ----------------------------------------------------
      // Mobile Snap Gallery Sync
      // ----------------------------------------------------
      if (mediaGrid && dots.length > 0) {
        let isScrolling;
        let currentMobileIndex = 1;

        mediaGrid.addEventListener('scroll', () => {
          // Clear timeout on scroll
          window.clearTimeout(isScrolling);
          
          // Set a timeout to run after scroll ends
          isScrolling = setTimeout(() => {
            const index = Math.round(mediaGrid.scrollLeft / mediaGrid.clientWidth) + 1;
            currentMobileIndex = index;
            
            // Sync dot indicator
            dots.forEach(dot => {
              if (parseInt(dot.getAttribute('data-dot-index')) === index) {
                dot.classList.add('active');
              } else {
                dot.classList.remove('active');
              }
            });
          }, 66);
        });

        // Clicking dots scrolls gallery
        dots.forEach(dot => {
          dot.addEventListener('click', () => {
            const index = parseInt(dot.getAttribute('data-dot-index'));
            currentMobileIndex = index;
            mediaGrid.scrollTo({
              left: (index - 1) * mediaGrid.clientWidth,
              behavior: 'smooth'
            });
          });
        });

        // Mobile Zoom Button Trigger
        const mobileZoomBtn = gallery.querySelector('.ecotrophy-mobile-zoom-btn');
        if (mobileZoomBtn) {
          mobileZoomBtn.addEventListener('click', () => {
            openModal(currentMobileIndex);
          });
        }

        // ── Custom Cursor (circle + plus icon that follows the mouse/touch) ──
        const customCursor = gallery.querySelector('[data-custom-cursor]');
        if (customCursor) {
          const desktopStack = gallery.querySelector('.ecotrophy-desktop-image-stack');
          const mobileSwiper = gallery.querySelector('.ecotrophy-swiper-mobile');

          // Attach to both desktop and mobile containers
          const cursorTargets = [desktopStack, mobileSwiper].filter(Boolean);

          cursorTargets.forEach(target => {
            // Mouse events (desktop)
            target.addEventListener('mouseenter', () => {
              customCursor.classList.add('visible');
            });

            target.addEventListener('mouseleave', () => {
              customCursor.classList.remove('visible');
            });

            target.addEventListener('mousemove', (e) => {
              customCursor.style.left = e.clientX + 'px';
              customCursor.style.top = e.clientY + 'px';
            });

            // Touch events (mobile)
            target.addEventListener('touchstart', (e) => {
              const touch = e.touches[0];
              customCursor.style.left = touch.clientX + 'px';
              customCursor.style.top = touch.clientY + 'px';
              customCursor.classList.add('visible');
            }, { passive: true });

            target.addEventListener('touchmove', (e) => {
              const touch = e.touches[0];
              customCursor.style.left = touch.clientX + 'px';
              customCursor.style.top = touch.clientY + 'px';
            }, { passive: true });

            target.addEventListener('touchend', () => {
              // Keep visible briefly then fade out
              setTimeout(() => {
                customCursor.classList.remove('visible');
              }, 600);
            });

            // Hide when image is clicked (modal opens)
            target.addEventListener('click', () => {
              customCursor.classList.remove('visible');
            });
          });
        }

        // Mobile Chevrons Navigation Click Triggers
        const prevArrow = gallery.querySelector('.ecotrophy-mobile-prev');
        const nextArrow = gallery.querySelector('.ecotrophy-mobile-next');
        if (prevArrow && nextArrow) {
          prevArrow.addEventListener('click', () => {
            if (currentMobileIndex > 1) {
              currentMobileIndex--;
              mediaGrid.scrollTo({
                left: (currentMobileIndex - 1) * mediaGrid.clientWidth,
                behavior: 'smooth'
              });
            }
          });

          nextArrow.addEventListener('click', () => {
            if (currentMobileIndex < dots.length) {
              currentMobileIndex++;
              mediaGrid.scrollTo({
                left: (currentMobileIndex - 1) * mediaGrid.clientWidth,
                behavior: 'smooth'
              });
            }
          });
        }
      }

      // ----------------------------------------------------
      // Variant Selector Sync
      // ----------------------------------------------------
      const updateVariantFromOptions = () => {
        if (!hiddenSelect || !hiddenSelect.options) return;
        // Collect currently selected options values
        const selectedValues = [];
        const activeSwatches = form.querySelectorAll('.allbirds-swatch-btn.active, .ecotrophy-swatch-btn.active');
        const selectedSizes = form.querySelectorAll('.allbirds-size-btn.active, .ecotrophy-size-btn.selected');
        const activeButtons = form.querySelectorAll('.ecotrophy-option-btn.active');
        
        activeSwatches.forEach(btn => {
          selectedValues.push(btn.getAttribute('data-color-val') || btn.getAttribute('data-value'));
        });
        selectedSizes.forEach(btn => {
          selectedValues.push(btn.getAttribute('data-size-val') || btn.getAttribute('data-value'));
        });
        activeButtons.forEach(btn => {
          selectedValues.push(btn.getAttribute('data-value'));
        });
        
        // Option values are joined by :: in the hidden select options
        const matchString = selectedValues.join('::');
        
        // Find matching select option
        let matchedOption = null;
        for (let i = 0; i < hiddenSelect.options.length; i++) {
          const opt = hiddenSelect.options[i];
          if (opt.getAttribute('data-options') === matchString) {
            matchedOption = opt;
            break;
          }
        }

        const hasSizeOption = form.querySelector('.size-option') !== null || form.querySelector('.allbirds-size-section') !== null;
        const sizeSelected = form.querySelector('.allbirds-size-btn.active') !== null || form.querySelector('.ecotrophy-size-btn.selected') !== null;

        if (matchedOption) {
          // Update selected option in hidden select
          hiddenSelect.value = matchedOption.value;
          
          // Update Price display (reads formatted string directly from option)
          if (priceText) {
            priceText.textContent = matchedOption.getAttribute('data-price');
          }

          // Update Compare Price and Discount Percentage
          const compPrice = matchedOption.getAttribute('data-compare-price');
          const compPriceRaw = parseFloat(matchedOption.getAttribute('data-compare-price-raw'));
          const priceRaw = parseFloat(matchedOption.getAttribute('data-price-raw'));

          if (comparePriceText) {
            if (compPrice && compPriceRaw > priceRaw) {
              comparePriceText.textContent = compPrice;
              comparePriceText.style.display = '';
              if (priceText) priceText.classList.add('sale-price');
              
              if (discountText) {
                const discountPercent = Math.round(((compPriceRaw - priceRaw) / compPriceRaw) * 100);
                discountText.textContent = `(${discountPercent}% off)`;
                discountText.style.display = '';
              }
            } else {
              comparePriceText.style.display = 'none';
              if (priceText) priceText.classList.remove('sale-price');
              if (discountText) discountText.style.display = 'none';
            }
          }

          // Update Availability / Cart Label / Add to Cart Active state
          if (addToCartBtn) {
            if (hasSizeOption && !sizeSelected) {
              addToCartBtn.disabled = true;
              addToCartBtn.classList.add('disabled');
              const span = addToCartBtn.querySelector('span');
              if (span) span.textContent = 'Select a Size';
              else addToCartBtn.textContent = 'Select a Size';
              addToCartBtn.setAttribute('aria-label', 'Select a size');
            } else {
              addToCartBtn.classList.remove('disabled');
              const isAvailable = matchedOption.getAttribute('data-available') === 'true';
              if (isAvailable) {
                addToCartBtn.disabled = false;
                const span = addToCartBtn.querySelector('span');
                if (span) span.textContent = 'Add to Cart';
                else addToCartBtn.textContent = 'Add to Cart';
                addToCartBtn.setAttribute('aria-label', 'Add product to cart');
              } else {
                addToCartBtn.disabled = true;
                const span = addToCartBtn.querySelector('span');
                if (span) span.textContent = 'Sold Out';
                else addToCartBtn.textContent = 'Sold Out';
                addToCartBtn.setAttribute('aria-label', 'Product is currently sold out');
              }
            }
          }

          // Scroll gallery to variant image (if set)
          const featuredImageId = matchedOption.getAttribute('data-image-id');
          if (featuredImageId) {
            const galleryItem = gallery.querySelector(`.ecotrophy-media-grid-item[data-media-id="${featuredImageId}"]`);
            if (galleryItem) {
              if (window.innerWidth < 750 && mediaGrid) {
                const itemLeft = galleryItem.offsetLeft;
                mediaGrid.scrollTo({ left: itemLeft, behavior: 'smooth' });
              } else {
                galleryItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            }
          }
        } else {
          // No direct variant matching this configuration
          if (addToCartBtn) {
            if (hasSizeOption && !sizeSelected) {
              addToCartBtn.disabled = true;
              addToCartBtn.classList.add('disabled');
              const span = addToCartBtn.querySelector('span');
              if (span) span.textContent = 'Select a Size';
              else addToCartBtn.textContent = 'Select a Size';
              addToCartBtn.setAttribute('aria-label', 'Select a size');
            } else {
              addToCartBtn.disabled = true;
              addToCartBtn.classList.add('disabled');
              const span = addToCartBtn.querySelector('span');
              if (span) span.textContent = 'Unavailable';
              else addToCartBtn.textContent = 'Unavailable';
              addToCartBtn.setAttribute('aria-label', 'Variant configuration unavailable');
            }
          }
        }
      };

      // Swatches selection triggers
      const swatchButtons = form ? form.querySelectorAll('.allbirds-swatch-btn, .ecotrophy-swatch-btn') : [];
      swatchButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const optionIndex = btn.getAttribute('data-option-index');
          const siblingSwatches = btn.parentElement.querySelectorAll('.allbirds-swatch-btn, .ecotrophy-swatch-btn');
          siblingSwatches.forEach(sib => sib.classList.remove('active'));
          btn.classList.add('active');

          const colorVal = btn.getAttribute('data-color-val') || btn.getAttribute('data-value');
          if (optionIndex) {
            const labelSpan = form.querySelector(`.color-option[data-option-index="${optionIndex}"] .ecotrophy-active-value-text`);
            if (labelSpan) {
              labelSpan.textContent = colorVal;
            }
          } else {
            const labelSpan = document.getElementById(`AsideSelectedColorName-${sectionId}`);
            if (labelSpan) {
              labelSpan.textContent = colorVal;
            }
          }
          updateVariantFromOptions();
        });
      });

      // Size Tabs gender switching triggers
      const sizeTabs = form ? form.querySelectorAll('.ecotrophy-size-tab') : [];
      sizeTabs.forEach(tab => {
        tab.addEventListener('click', () => {
          sizeTabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
        });
      });

      // Size buttons grid triggers
      const sizeButtons = form ? form.querySelectorAll('.allbirds-size-btn, .ecotrophy-size-btn') : [];
      sizeButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.classList.contains('out-of-stock')) return;
          
          const optionIndex = btn.getAttribute('data-option-index');
          const siblingButtons = btn.parentElement.querySelectorAll('.allbirds-size-btn, .ecotrophy-size-btn');
          siblingButtons.forEach(sib => {
            sib.classList.remove('selected');
            sib.classList.remove('active');
          });
          btn.classList.add('selected');
          btn.classList.add('active');

          updateVariantFromOptions();
        });
      });

      // Click event for custom option buttons
      optionButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const optionIndex = btn.getAttribute('data-option-index');
          const siblingButtons = btn.parentElement.querySelectorAll('.allbirds-swatch-btn, .allbirds-size-btn, .ecotrophy-option-btn');
          siblingButtons.forEach(sib => {
            sib.classList.remove('active');
            sib.classList.remove('selected');
          });
          btn.classList.add('active');

          const labelSpan = document.getElementById(`ActiveOptionValue-${sectionId}-${optionIndex}`);
          if (labelSpan) {
            labelSpan.textContent = btn.getAttribute('data-value');
          }
          updateVariantFromOptions();
        });
      });

      // ----------------------------------------------------
      // Quantity Selector Controls
      // ----------------------------------------------------
      if (qtyInput && qtyPlusBtn && qtyMinusBtn) {
        qtyPlusBtn.addEventListener('click', () => {
          let val = parseInt(qtyInput.value) || 1;
          qtyInput.value = val + 1;
        });

        qtyMinusBtn.addEventListener('click', () => {
          let val = parseInt(qtyInput.value) || 1;
          if (val > 1) {
            qtyInput.value = val - 1;
          }
        });

        qtyInput.addEventListener('change', () => {
          let val = parseInt(qtyInput.value) || 1;
          if (val < 1) qtyInput.value = 1;
        });
      }

      // ----------------------------------------------------
      // WhatsApp Bulk Order Generator
      // ----------------------------------------------------
      if (whatsappBtn) {
        whatsappBtn.addEventListener('click', () => {
          const productTitle = whatsappBtn.getAttribute('data-product-title');
          const qty = qtyInput ? qtyInput.value : 1;
          
          // Build option descriptors
          const optionLabels = [];
          const activeButtons = form.querySelectorAll('.ecotrophy-option-btn.active');
          activeButtons.forEach(btn => {
            const optIndex = btn.getAttribute('data-option-index');
            const optWrapper = btn.closest('.ecotrophy-option-wrapper');
            const optLabel = optWrapper ? optWrapper.querySelector('.ecotrophy-option-label').textContent.split(':')[0].trim() : 'Option';
            optionLabels.push(`${optLabel}: ${btn.getAttribute('data-value')}`);
          });

          const optString = optionLabels.length > 0 ? ` (${optionLabels.join(', ')})` : '';
          const currentUrl = window.location.href;

          const textMessage = `Hi Ecotrophy! I would like to get a custom/bulk quote for:\n\n*Product:* ${productTitle}${optString}\n*Quantity:* ${qty}\n*Link:* ${currentUrl}`;
          const encodedText = encodeURIComponent(textMessage);
          
          // WhatsApp Click to Chat URL (use real Ecotrophy business number or a default fallback)
          const whatsappNumber = '919000000000'; // Replace with Ecotrophy's official phone
          window.open(`https://wa.me/${whatsappNumber}?text=${encodedText}`, '_blank');
        });
      }
    });
  };

  initEcotrophyPDP();
  
  // Custom event listener for Shopify Section Load (so it works inside Theme Customizer preview!)
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('section-ecotrophy-product-main') || event.target.querySelector('.ecotrophy-product-container')) {
      initEcotrophyPDP();
    }
  });
});
